import http from '@/http'
const URL = '/admin/settings/wa'

export const GetSettingWA = () => http.get(URL)
export const waTemplates = () => http.get(URL + '/templates')
export const saveWA = (payload) => http.post(URL + `/${payload.id}`, payload)

// FAQ
export const getFaqs = () => http.get(URL + '/faq')
export const createFaq = (payload) => http.post(URL + '/faq', payload)
export const updateFaq = (id, payload) => http.put(URL + `/faq/${id}`, payload)
export const deleteFaq = (id) => http.delete(URL + `/faq/${id}`)
export const reorderFaqs = (ids) => http.post(URL + '/faq/reorder', { ids })

export default {
  GetSettingWA,
  waTemplates,
  saveWA,
  getFaqs,
  createFaq,
  updateFaq,
  deleteFaq,
  reorderFaqs
}
